import React, { useState, useEffect } from "react";
import { Snackbar, Alert } from "@mui/material";
import { apiGet, apiPut } from "../../utils/api";
import { useHistory, Link, useParams } from "react-router-dom";

const defaultState = {
  author: "",
  type: "",
  title: "",
  year: "",
  access_link: "",
};

const ThesisEdit = () => {
  const { id } = useParams();

  const history = useHistory();

  const [state, setState] = useState(defaultState);

  const [snack, setSnack] = useState({
    open: false,
    message: "Default message",
    severity: "success",
  });

  const showSnack = (message, severity) => {
    setSnack({
      ...snack,
      open: true,
      message: message,
      severity: severity,
    });
  };

  const handleSnackClose = (e) => {
    setSnack({ ...snack, open: false });
  };

  async function editar(state) {
    const payload = apiPut("/thesis/" + id, state);
    return await payload;
  }

  async function toLogin() {
    history.push("/login");
  }

  const handleChange = (e) => {
    const target = e.target;
    const name = target.name;

    setState((previousState) => {
      return { ...previousState, [name]: target.value };
    });
  };

  const submitHandler = (e) => {
    e.preventDefault();

    if (state.type.trim().length === 0) {
      showSnack("Selecione o Tipo.", "warning");
      return;
    }
    if (state.author.trim().length === 0) {
      showSnack("Campo Autor(es) inválido.", "warning");
      return;
    }
    if (state.title.trim().length === 0) {
      showSnack("Informe o Título.", "warning");
      return;
    }
    if (state.year.toString().trim().length === 0) {
      showSnack("Informe o Ano.", "warning");
      return;
    }

    editar(state).then(
      (payload) => {
        showSnack("Tese/Dissertação atualizada sucesso.", "success");
      },
      (error) => {
        let message =
          "Erro ao atualizar. Revise as informações e tente novamente!";

        if (error.response.status === 401) {
          message = "Sem autorização.";
          toLogin();
        }

        showSnack(message, "error");
      }
    );
  };

  async function buscar() {
    const payload = apiGet("/thesis/" + id);
    const data = (await payload).data.data;
    return data;
  }

  useEffect(() => {
    buscar().then(
      (data) => {
        if (data != null) {
          setState(data);
        } else {
          setState({ title: "Nenhum trabalho encontrado." });
        }
      },
      () => {
        setState({ title: "Nenhum trabalho encontrado." });
      }
    );
  }, []);

  return (
    <>
      <section id="management" style={{ paddingTop: "100px" }}>
        <div className="row text-center justify-content-center">
          <h2 className="text-black mb-4">Edição de Teses e Dissertações</h2>
        </div>
      </section>
      <div className="row mx-5 justify-content-center">
        <div className="col-md-5">
          <form onSubmit={submitHandler}>
            <label htmlFor="subject">Tipo</label>

            <select name="type" onChange={handleChange} value={state.type}>
              <option value="">Selecione o tipo:</option>
              <option value="Dissertação">Dissertação de mestrado</option>
              <option value="Tese">Tese de doutorado</option>
            </select>

            <label htmlFor="author">Autor(es):</label>
            <input
              type="text"
              name="author"
              onChange={handleChange}
              value={state.author}
            />

            <label htmlFor="title">Título:</label>
            <input
              type="text"
              name="title"
              onChange={handleChange}
              value={state.title}
            />

            <label htmlFor="year">Ano:</label>
            <input
              type="text"
              name="year"
              onChange={handleChange}
              value={state.year}
            />

            <label htmlFor="access_link">Link da publicação:</label>
            <input
              type="text"
              name="access_link"
              onChange={handleChange}
              value={state.access_link}
            />

            <input type="submit" value="Atualizar" />
          </form>

          <Snackbar
            open={snack.open}
            autoHideDuration={6000}
            onClose={handleSnackClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
            <Alert
              onClose={handleSnackClose}
              severity={snack.severity}
              sx={{ width: "100%" }}
            >
              {snack.message}
            </Alert>
          </Snackbar>

          <div>
            <Link className="btn btn-secondary" to="/management/thesis/admin">
              Voltar
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default ThesisEdit;
